const DEV_ALLOWED_EXTRA_EMAILS = [
    'paulofurtadojunior@gmail.com',
    'ratoeira.ads@gmail.com',
    'leitorguimaraes@gmail.com',
];

export function isAllowedDevEmail(email: string | null | undefined): boolean {
    const normalized = (email ?? '').trim().toLowerCase();
    if (!normalized) {
        return false;
    }
    if (normalized.endsWith('@ratoeiraads.com')) {
        return true;
    }
    return DEV_ALLOWED_EXTRA_EMAILS.includes(normalized);
}
